import { createFileRoute } from '@tanstack/react-router'
import { type TKey, translateApp } from '@/lib/i18n'
import { formatLegalDate, LegalPage } from './terms'

export const Route = createFileRoute('/privacy')({
	ssr: true,
	component: PrivacyPage
})

function PrivacyPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = (key: TKey) => translateApp(appLanguage, key)

	return (
		<LegalPage
			appLanguage={appLanguage}
			eyebrow={t('common:legal.eyebrow')}
			lastUpdated={translateApp(
				appLanguage,
				'common:legal.last_updated',
				{
					date: formatLegalDate(appLanguage)
				}
			)}
			title={t('common:legal.privacy.title')}
		>
			<h2>{t('common:legal.privacy.data.title')}</h2>
			<p>{t('common:legal.privacy.data.description')}</p>
			<h2>{t('common:legal.privacy.purposes.title')}</h2>
			<p>{t('common:legal.privacy.purposes.description')}</p>
			<h2>{t('common:legal.privacy.retention_and_rights.title')}</h2>
			<p>{t('common:legal.privacy.retention_and_rights.description')}</p>
		</LegalPage>
	)
}
